~<template>
  <div id="app">
    <header class="header">
      <div class="container">
        <nav class="nav">
          <!-- 移动端汉堡菜单按钮 -->
          <button class="mobile-menu-btn" @click="mobileMenuOpen = !mobileMenuOpen" aria-label="菜单">
            <span class="hamburger" :class="{ active: mobileMenuOpen }">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          
          <div class="logo" @click="changeMenu(1)" style="cursor:pointer;">
            <img src="/logo.png" alt="Linkoffer Logo" class="logo-icon" width="32" height="32">
            <span>Linkoffer</span>
          </div>
          <!-- 桌面端导航 -->
          <div class="nav-links desktop-nav">
            <a class="nav-link" :class="{active: activeIndex === 1}" @click="changeMenu(1)">首页</a>
            <a class="nav-link" :class="{active: activeIndex === 2}" @click="changeMenu(2)">教程中心</a>
            <a class="nav-link" :class="{active: activeIndex === 3}" @click="changeMenu(3)">会员充值</a>
            <a class="nav-link" :class="{active: activeIndex === 4}" @click="changeMenu(4)">下载中心</a>
            <a class="nav-link" :class="{active: activeIndex === 5}" @click="changeMenu(5)">联系我们</a>
          </div>
          
          <div class="nav-actions">
            <button class="register-btn" v-if="!store.isLogin" @click="handleRegister">注册</button>
            <button class="login-btn" v-if="!store.isLogin" @click="handleLogin">登录</button>
            <div v-if="store.isLogin">
              <el-popover placement="bottom" trigger="hover" width="200px" :hide-after="0" popper-class="user-popover">
                <template #reference>
                  <div class="user-info">
                  <div class="user-avatar">
                      <iconify-icon icon="fa-solid:user-circle" class="user-avatar-icon" />
                    </div>
                    <!-- <span class="username">{{ (store.userInfo?.phone || '我').substring(0,1) }}</span> -->
                    <iconify-icon icon="fa-solid:chevron-down" class="dropdown-icon" />
                  </div>
                </template>
                <div class="user-menu">
                  <div class="user-menu-header">
                    <div class="user-avatar-large">
                      <iconify-icon icon="fa-solid:user-circle" width="48" height="48" />
                    </div>
                    <div class="user-details">
                      <div class="user-name">{{ (store.userInfo?.phone || '我') }}</div>
                      <div class="user-email">{{ store.userInfo?.email || 'user@example.com' }}</div>
                    </div>
                  </div>
                  <div class="user-menu-divider"></div>
                  <div class="user-menu-items">
                    <div class="menu-item" @click="handleMenuSelect('1')">
                      <iconify-icon icon="fa-solid:user" width="16" height="16" />
                      <span>用户中心</span>
                    </div>
                    <div class="menu-item" @click="handleMenuSelect('2')">
                      <iconify-icon icon="fa-solid:sign-out-alt" width="16" height="16" />
                      <span>退出登录</span>
                    </div>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </nav>
      </div>
    </header>
    
    <!-- 移动端侧边抽屉菜单 -->
    <transition name="drawer-slide">
      <div class="mobile-drawer" v-if="mobileMenuOpen">
        <nav class="drawer-nav">
          <a class="drawer-nav-link" :class="{active: activeIndex === 1}" @click="changeMenu(1); mobileMenuOpen = false">
            <iconify-icon icon="fa-solid:home" width="18" height="18" />
            <span>首页</span>
          </a>
          <a class="drawer-nav-link" :class="{active: activeIndex === 2}" @click="changeMenu(2); mobileMenuOpen = false">
            <iconify-icon icon="fa-solid:book" width="18" height="18" />
            <span>教程中心</span>
          </a>
          <a class="drawer-nav-link" :class="{active: activeIndex === 3}" @click="changeMenu(3); mobileMenuOpen = false">
            <iconify-icon icon="fa-solid:credit-card" width="18" height="18" />
            <span>会员充值</span>
          </a>
          <a class="drawer-nav-link" :class="{active: activeIndex === 4}" @click="changeMenu(4); mobileMenuOpen = false">
            <iconify-icon icon="fa-solid:download" width="18" height="18" />
            <span>下载中心</span>
          </a>
          <a class="drawer-nav-link" :class="{active: activeIndex === 5}" @click="changeMenu(5); mobileMenuOpen = false">
            <iconify-icon icon="fa-solid:envelope" width="18" height="18" />
            <span>联系我们</span>
          </a>
        </nav>
      </div>
    </transition>
    
    <div class="home-root"  v-if="activeIndex === 1">
    <main>
      <!-- Hero Section -->
      <section class="hero">
        <div class="hero-container">
          <div class="hero-content">

            <h2 class="hero-title">AI 模拟面试助手</h2>
            <p class="hero-description">专为学生群体打造的高性价比产品</p>
            <p class="hero-description">不仅是陪练，更是你面试时的“心理防线”</p>
            <button class="btn btn-primary btn-large" @click="handleInterview">立即开始</button>
          </div>
          <div class="explore-more" :class="{ 'hidden': isScrolled }" @click="scrollToFeatures">
            <span>探索更多</span>
            <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
              <polyline points="6,9 12,15 18,9"/>
            </svg>
          </div>
        </div>
      </section>

      <!-- Features Overview Section -->
      <section id="features-overview" class="section">
        <div class="container">
          <h2 class="section-title">功能速览</h2>
          <div class="features-overview-container">
            <div class="feature-overview-image">
              <img src="/homepicture.jpg" alt="AI面试助手功能展示" >
              <!-- <div class="feature-overview-overlay">
                <div class="feature-highlight left">
                  <div class="highlight-dot"></div>
                  <div class="highlight-text">实时AI提示</div>
                </div>
                <div class="feature-highlight right">
                  <div class="highlight-dot"></div>
                  <div class="highlight-text">智能回答生成</div>
                </div>
              </div> -->
            </div>
            <div class="feature-overview-caption">
              <div class="caption-text">PC端模拟视频面试，手机端即时提示</div>
              <div class="caption-subtext">无需死记硬背，灵感即刻同步</div>
            </div>
          </div>
        </div>
      </section>

      <!-- Video Section -->
      <section class="section">
        <div class="container">
          <h2 class="section-title">产品演示</h2>
          <div class="video-container">
            <div class="video-thumbnail" @click="playVideo">
              <img src="/homevideo.jpg" alt="产品演示视频" />
              <div class="play-button">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="white">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>


         <!-- Features Section -->
      <section class="section">
        <div class="container">
          <h2 class="section-title">产品优势</h2>
          <div class="features-grid">
            <div class="feature-card">
              <div class="feature-icon">
                <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <rect x="3" y="3" width="18" height="18" rx="4"/>
                  <path d="M9 9h6v6H9z"/>
                </svg>
              </div>
              <h3>全网最低价</h3>
              <p>让利给想进好公司的你，拒绝营销套路，随用随充</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">
                <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M8 15h8M8 11h8M8 7h8"/>
                </svg>
              </div>
              <h3>大模型优化</h3>
              <p>微调全球Top大语言模型，答题更准、更有针对性</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">
                <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <path d="M3 17l6-6 4 4 8-8"/>
                  <circle cx="19" cy="5" r="2"/>
                </svg>
              </div>
              <h3>AI 模拟面试</h3>
              <p>还原真实场景，让你应答从容</p>
            </div>
            <div class="feature-card">
              <div class="feature-icon">
                <svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                  <rect x="3" y="11" width="18" height="10" rx="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <h3>隐私安全保障</h3>
              <p>多重加密与匿名化，严格数据保密</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Platforms Section -->
      <section class="section">
        <div class="container">
          <h2 class="section-title">可支持平台</h2>
          <div class="platforms-grid">
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/zoom.png')" alt="Zoom" class="platform-logo">
              </div>
              <span>Zoom</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/tencentmeeting.png')" alt="腾讯会议" class="platform-logo">
              </div>
              <span>腾讯会议</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/skype.png')" alt="Skype" class="platform-logo">
              </div>
              <span>Skype</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/dingding.png')" alt="钉钉" class="platform-logo">
              </div>
              <span>钉钉</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/feishu.png')" alt="飞书" class="platform-logo">
              </div>
              <span>飞书</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/boss.png')" alt="BOSS直聘" class="platform-logo">
              </div>
              <span>BOSS直聘</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/zhilian.png')" alt="智联招聘" class="platform-logo">
              </div>
              <span>智联招聘</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/teams.png')" alt="Microsoft Teams" class="platform-logo">
              </div>
              <span>Microsoft Teams</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/meet.png')" alt="Google Meet" class="platform-logo">
              </div>
              <span>Google Meet</span>
            </div>
            <div class="platform-card">
              <div class="platform-icon">
                <img :src="require('@/assets/platform/web.png')" alt="网页面试" class="platform-logo">
              </div>
              <span>网页面试</span>
            </div>
          </div>
        </div>
      </section>

   

      <!-- FAQ Section -->
      <section class="faq-section-custom">
        <div class="faq-container">
          <h2 class="section-title">常见问题</h2>
          <div class="faq-container">
            <div class="faq-grid">
              <div
                class="faq-item"
                v-for="(question, idx) in questions"
                :key="idx"
                @mouseenter="showTooltip = idx + 1"
                @mouseleave="showTooltip = 0"
              >
                <div class="faq-question">{{ question.title }}</div>
                <div class="faq-tooltip" v-show="showTooltip === idx + 1">
                  {{ question.answer }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <span>© 2025-2026 Linkoffer. 保留所有权利.</span>
        
          <a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2025179319号-1</a>
          <span>联系方式：linkoffer@yeah.net</span>
        </div>
      </div>
    </footer>

    <!-- 登录弹窗组件 -->
    <LoginModal ref="loginModal" />

    <!-- 活动入口卡片（新人福利上方） -->
    <a class="activity-fab" href="/activity.html" target="_blank" v-if="showActivityCard">
      <div class="activity-fab-content">
        <div class="activity-fab-text-container">
          <h3 class="activity-fab-title">🎁 邀请有礼活动入口</h3>
          <p class="activity-fab-desc">老带新福利升级，多邀多得，上不封顶</p>
        </div>
      </div>
      <button class="close-notice" @click.prevent="showActivityCard = false" aria-label="关闭">×</button>
    </a>

    <!-- 浮动通知窗口 -->
    <div 
      class="floating-notice" 
      v-if="showFloatingAd"
      :style="floatingAdStyle"
    >
      <div class="notice-content">
        <div class="notice-text-container">
          <h3 class="notice-title">新人福利</h3>
          <p class="notice-text">注册立得面试币｜解锁AI功能免费体验 | 30天有效</p>
        </div>
        <button class="close-notice" @click="closeFloatingAd" aria-label="关闭">×</button>
      </div>
    </div>

    <!-- 活动入口卡片（已移到左上角） -->
    <!-- 下方 a.activity-fab 已删除 -->
  </div>


    <div class="page-content">
      <!-- 保留原有内容区结构 -->
      
      <TutorialCenter v-if="activeIndex == 2" :showUserAgreementProp="showUserAgreement"></TutorialCenter>
      <Price v-if="activeIndex == 3"></Price>
      <ContactUs v-if="activeIndex == 5"></ContactUs>
      <main v-if="activeIndex == 4">
        <div class="download-root">
          <div class="download-content">
            <div class="container">
              <h1 class="page-title">客户端下载</h1>
              <p class="download-tip">下载客户端配合网页使用，产品使用教程请看 <a href="#" @click.prevent="goToTutorialCenter" class="tutorial-link">教程中心</a></p>
              
              <div class="download-grid">
                <!-- Windows -->
                <div class="download-card" @click="downloadWindows">
                  <div class="download-platform-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-12.9-1.801"/>
                    </svg>
                  </div>
                  <div class="platform-info">
                    <h3>Windows</h3>
                    <p class="platform-support">支持 Windows 10/11</p>
                  </div>
                  <button class="btn-download">下载</button>
                </div>

                <!-- MacOS -->
                <div class="download-card" @click="downloadMacOS">
                  <div class="download-platform-icon">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                    </svg>
                  </div>
                  <div class="platform-info">
                    <h3>MacOS</h3>
                    <p class="platform-support">支持 MacOS 13.1 及以上版本</p>
                  </div>
                  <button class="btn-download">下载</button>
                </div>

                <!-- Android -->
                <div class="download-card">
                  <div class="download-platform-icon disabled">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="5" y="2" width="14" height="20" rx="2"/>
                      <path d="M12 18h.01"/>
                    </svg>
                  </div>
                  <div class="platform-info">
                    <h3>Android</h3>
                    <p class="platform-support">支持 Android 9 及以上版本</p>
                  </div>
                  <button class="btn-download disabled">敬请期待</button>
                </div>

                <!-- iOS -->
                <div class="download-card">
                  <div class="download-platform-icon disabled">
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="5" y="2" width="14" height="20" rx="2"/>
                      <path d="M12 18h.01"/>
                    </svg>
                  </div>
                  <div class="platform-info">
                    <h3>iOS</h3>
                    <p class="platform-support">支持 iOS 15 及以上版本</p>
                  </div>
                  <button class="btn-download disabled">敬请期待</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
     
          <register 
          :visible="dialogRegisterVisible" 
          v-if="dialogRegisterVisible" 
          @close="dialogRegisterVisible = false"
          @registerSuccess="handlerRegisterSuccess">
        </register>
 
         <Login 
         :visible="dialogLoginVisible"
          v-if="dialogLoginVisible" 
          @close="dialogLoginVisible = false" 
          @loginSuccess="handlerLoginSuccess">
        </Login>
      
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "../api/login/login";
import Register from "./register.vue";
import Login from "./Login.vue";
import ContactUs from "@/views/HomepageMenu/ContactUs.vue"; //  联系我们
import Price from "@/views/HomepageMenu/Pricing.vue"; //  定价与购买
import TutorialCenter from "@/views/HomepageMenu/TutorialCenter.vue"; // 教程中心
import { useStore } from "../store";
export default {
  name: 'HomepageComponent',  // 添加或修改为多词名称
  components: {
    register: Register,
    Login: Login,
    ContactUs: ContactUs, // 注册 ContactUs 组件
    Price: Price, // 注册 Price 组件
    TutorialCenter: TutorialCenter, // 注册 TutorialCenter 组件
  },
  data() {
    return {
      mobileMenuOpen: false, // 移动端菜单展开状态
      currentImage: 1, // 默认显示第一张图片
      currentSelected: 0,
      countdown: 5, // 倒计时时间（秒）
      timer: null, // 定时器变量
      featureItems: [
        { title: "AI实时精准作答", description: "作为您的AI模拟面试助手，AI将实时精准识别面试问题，并在xx毫秒内给出回答建议，提升面试技能、轻松通过招聘" },
        { title: "覆盖全网多个岗位", description: "采用先进的大语言模型，知识库覆盖众多大厂，产品支持编程/产品经理/运营/市场/律师/金融等多个岗位" },
        { title: "随用随充，优享低价", description: "没有套路，不需预充。提供低于市面的价格，您可根据实际需求随用随充，无忧退款" }
      ],
      store: null, // 全局状态管理
      dialogVisible: false,
      // 注册弹窗标识
      dialogRegisterVisible: false,
      // 登录弹窗标识
      dialogLoginVisible: false,
      activeIndex: 1,
      defaultActive:  '1',
      showUserAgreement: false, // 控制是否显示用户协议
      showContactUs: false, // 控制是否显示联系我们内容
      features: [
        {
          icon: require("../assets/image/picture2.png"),
          title: "AI实时辅导",
          description: "在您面试中实时识别语音、转文字，实时提供AI辅导",
        },
        {
          icon: require("../assets/image/picture2.png"),
          title: "隐身效果",
          description:
            "支持多端互联，客户端采集音频/网页端输出，可在面试中完美隐身",
        },
        {
          icon: require("../assets/image/picture2.png"),
          title: "零延迟",
          description: "毫秒级给出快速回答，x秒内给出精确回答",
        },
      ],
      caseList: [
        {
          avatar: require("../assets/image/picture3.jpg"),
          name: "张三",
          position: "高级软件工程师",
          quote: "使用后成功通过大厂面试，推荐！",
        },
        {
          avatar: require("../assets/image/picture3.jpg"),
          name: "李四",
          position: "高级软件工程师",
          quote: "使用后成功通过大厂面试，推荐！",
        },
        {
          avatar: require("../assets/image/picture3.jpg"),
          name: "王五",
          position: "高级软件工程师",
          quote: "使用后成功通过大厂面试，推荐！",
        },
        {
          avatar: require("../assets/image/picture3.jpg"),
          name: "王五",
          position: "高级软件工程师",
          quote: "使用后成功通过大厂面试，推荐！",
        },
        // 添加更多案例...
      ],

      questions: [
        {
          title: "如何使用我们的产品？",
          answer:
            "您需要下载Linkoffer客户端，推荐您使用电脑端的视频软件进行模拟面试，用移动端（平板/手机）浏览器登录Linkoffer网页（www.linkoffer.cn），根据页面提示使用产品，详情见\"教程中心\"。",
        },
        {
          title: "支持哪些岗位的面试辅导？",
          answer:
            "支持编程/产品经理/运营/市场/律师/金融等多个岗位。",
        },
        {
          title: "支持哪些面试平台？",
          answer:
            "我们支持绝大多数的视频会议软件，常见的客户端如腾讯会议/飞书/钉钉等均可使用，同时支持网页端面试。",
        },
        {
          title: "产品怎么收费?",
          answer:
            "价格远低于市面上的同类产品，且充值模式无套路，您可根据需要购买所需 额度，随用随充，用不完的余额支持退款，详情见\"会员充值\"页面。",
        }
       
        // {
        //   title: "如何免费使用我们的产品？",
        //   answer:
        //     "把我们的产品推荐给您的同学/朋友，好友可使用您的邀请码注册，在您的好友消费后， 您可获得好友首次消费金额的10%作为奖励，可前往\"个人中心\"查看您的邀请码。",
        // },
        // 添加更多问题...
      ],
      activeNames: [0], // 默认展开第一个，索引从 0 开始
      form: {
        title: "",
        content: "",
      },
      showTooltip: 0,
      isScrolled: false,
      showFloatingAd: true,  // 控制浮动通知显示
      showActivityCard: true, // 控制活动卡片显示

      // 浮动通知背景样式
      floatingAdStyle: {
        background: 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 60%, #3b82f6 100%)'
      },
    };
  },
  created() {
    this.store = useStore();
    console.log("store:", this.store);
    // 从路由 query 参数中获取 activeIndex
    const queryActiveIndex = this.$route.query.activeIndex;
    const showUserAgreement = this.$route.query.showUserAgreement;
    if (queryActiveIndex) {
      this.activeIndex = parseInt(queryActiveIndex, 10);
      this.showUserAgreement = showUserAgreement;
      console.log("showUserAgreement:", showUserAgreement);
      this.$router.push("/home");
    }
  },
  watch: {
    $route(to) {  // 移除from参数
      // 路由变化时更新 activeIndex
      const queryActiveIndex = to.query.activeIndex;
      if (queryActiveIndex) {
        this.activeIndex = parseInt(queryActiveIndex, 10);
        
        this.defaultActive = this.activeIndex.toString();
        console.log("activeIndex:", this.activeIndex);
        this.$router.push("/home");
      }
    },
    activeIndex(newVal) {
      // activeIndex值变化时执行逻辑
      this.defaultActive = newVal.toString();
      console.log("activeIndex变化为:", newVal);
    }
  },


  methods: {
    goToTutorialCenter() {
      this.defaultActive = '2'; // 设置 activeIndex 为 2
       this.activeIndex = 2;
    },
    startAutoSwitch() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown = Math.max(0, this.countdown - 0.1); // 精度控制
        } else {
          this.currentSelected = (this.currentSelected + 1) % this.featureItems.length;
          this.showImage(this.currentSelected);
          this.countdown = 5;
        }
      }, 100); // 每 100ms 更新一次
    },
    showImage(index) {
      this.currentImage = index + 1;
      this.currentSelected = index;
      this.countdown = 5;
    },
    changeMenu(index) {
      this.activeIndex = index;
    },
    handleInterview() {
      console.log("开始面试");
      if (this.store.isLogin === false) {
        this.$message.error("请先登录");
        return;
      }
      window.open(this.$router.resolve({ name: 'InterviewPage',
         query: { activeIndex: 2,showUserAgreement:true }}).href, '_blank');
      // this.$router.push("/interview");
    },
    handleMenuSelect(index) {
      if (index === "1") {
        // this.$router.push('/userInfo');
        const routeUrl = this.$router.resolve({
          name: "userInfo", // 假设 Homepage 的路由名称为 'Homepage'
          query: { activeIndex: 4 }, // 通过 query 参数传递 activeIndex
        });
        window.open(routeUrl.href, "_blank");
      } else if (index === "2") {
        this.handleLoginOut();
      }
    },
     // 退出登录
    async handleLoginOut() {
        // 退出登录逻辑
        this.store = useStore();
        console.log("store:", this.store);
        console.log("store:", this.store.isLogin);
        this.store.isLogin = false;
        //  清除token
        this.store.token =""
        //  清除刷新token
        this.store.refreshToken = "" // res.data.refreshToken
    },


    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => {});
    },
    handleRegister() {
      console.log("注册信息:", this.form);
      this.dialogRegisterVisible = true;
      // 这里添加注册逻辑
      // console.log('注册信息:', this.form);
      // 实际项目中需要添加表单验证和注册请求
    },
    handleLogin() {
      this.dialogLoginVisible = true;
    },
    handlerLoginSuccess(val) {
      console.log("登录成功:", val);  // 打印登录成功信息
      const store = useStore();
      //  缓存token
      store.token = val.token
      //  缓存刷新token
      store.refreshToken = val.token; // res.data.refreshToken
      store.isLogin = true;
      this.dialogLoginVisible = false;
      this.getUserInfo();
    },
    handlerRegisterSuccess(val) {
      console.log("注册成功:", val);
      this.dialogRegisterVisible = false;
      this.$notify({
        title: '成功',
        message: '注册成功，请登录',
        type: 'success',
        duration: 2000
      });
    },
     // 获取用户信息
    async getUserInfo() {
       // 准备登录信息
      const obj = Object.assign({}, this.form);
      const response = await getUserInfo(obj)
      if (response.code === 200) {
         const store = useStore();
         //  缓存当前登录用户信息
         store.userInfo = response.data;
        }
    },

    downloadMacOS() {
      // macOS 下载逻辑 - 暂时使用Windows版本
      const filePath = './Linkoffer_1.0.0_Universal_macOS.dmg';
      
      // 创建一个临时的a标签来触发下载
      const link = document.createElement('a');
      link.href = filePath;
      link.download = 'Linkoffer_1.0.0_Universal_macOS.dmg';
      link.style.display = 'none';
      
      // 添加到DOM中
      document.body.appendChild(link);
      
      // 触发点击下载
      link.click();
      
      // 清理DOM
      document.body.removeChild(link);
      
      // 显示下载提示
      this.$message.success('开始下载macOS客户端...');
    },
    downloadWindows() {
      // Windows 下载逻辑 - 下载本地文件
      const filePath = './Linkoffer_Setup_v1.0.0.exe';
      
      // 创建一个临时的a标签来触发下载
      const link = document.createElement('a');
      link.href = filePath;
      link.download = 'Linkoffer_Setup_v1.0.0.exe';
      link.style.display = 'none';
      
      // 添加到DOM中
      document.body.appendChild(link);
      
      // 触发点击下载
      link.click();
      
      // 清理DOM
      document.body.removeChild(link);
      
      // 显示下载提示
      this.$message.success('开始下载Windows客户端...');
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.currentPage = Math.floor(scrollTop / this.pageHeight);
      // 可根据 currentPage 切换页面内容
    },
    scrollToFeatures() {
      const featuresSection = document.getElementById('features-overview');
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    handleScrollExploreMore() {
      this.isScrolled = window.scrollY > 100;
    },
    playVideo() {
      window.open('https://www.bilibili.com/video/BV1Mc1VBFEPM/?vd_source=a250cf4fdf0a7ba7afb23233c5a18ab3', '_blank');
    },

    // 关闭浮动通知
    closeFloatingAd() {
      this.showFloatingAd = false;
    },
    // 打开注册弹窗
    openRegister() {
      this.dialogRegisterVisible = true;
    },
  },
  mounted() {
    this.startAutoSwitch();
    window.addEventListener('scroll', this.handleScrollExploreMore);
  },
  computed: {
    currentImageSrc() {
      switch (this.currentImage) {
        case 1:
          return require('../assets/image/picture1.jpg');
        case 2:
          return require('../assets/image/picture0.jpg');
        case 3:
          return require('../assets/image/picture0.jpg');
        default:
          return '';
      }
    },
    logoUrl() {
      return '/favicon.svg';
    },
    feature_overview() {
      return require('../assets/overview/feature-overview.jpeg');
    }
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener('scroll', this.handleScrollExploreMore);
  },
};
</script>
  
<style scoped>
/* Reset and Base */
* {
  box-sizing: border-box;
}

.home-root {
  min-height: 100vh;
  background: #ffffff;
  color: #1a1a1a;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Inter', 'PingFang SC', 'Microsoft YaHei', Arial, sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  background: transparent;
}

.btn-primary {
  background: linear-gradient(135deg, #2563eb, #60a5fa);
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #1d4ed8, #3b82f6);
  transform: translateY(-2px);
}

.btn-large {
  padding: 20px 40px;
  font-size: 1.1rem;
  border-radius: 12px;
  font-weight: 600;
}

/* Hero Section */
.hero {
  padding: 30px 0 80px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  text-align: center;
}

.hero-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 24px;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.hero-title {
  font-size: 50px;
  font-weight: 800;
  margin-top: 100px;
  margin-bottom: 30px;
  background: linear-gradient(135deg, #1a1a1a, #333333);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;  /* 标准属性放在最后 */
}

.hero-subtitle {
  font-size: 1.5rem;
  color: #666;
  margin: 0;
  font-weight: 600;
}

.hero-description {
  font-size: 1rem;
  color: #888;
  margin: 5px;
  max-width: 600px;
  line-height: 1.6;
}

.hero-description:last-of-type {
  margin-bottom: 90px;
}

.explore-more {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 60px;
  color: #888;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  opacity: 1;
  transform: translateY(0);
  cursor: pointer;
}

.explore-more.hidden {
  opacity: 0;
  transform: translateY(20px);
  pointer-events: none;
}

.explore-more svg {
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* Sections */
.section {
  padding: 100px 0;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  text-align: center;
  margin: 0 0 60px 0;
  letter-spacing: -0.02em;
}

/* Video Section */
.video-container {
  margin: 40px 0;
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0);
}

.video-container video {
  width: 100%;
  height: 600px;
  border-radius: 20px;
  box-shadow: 0 12px 50px rgba(0, 0, 0, 0);
  object-fit: cover;
}

.video-thumbnail {
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 20px;
  overflow: hidden;
}

.video-thumbnail img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.video-thumbnail:hover img {
  transform: scale(1.05);
}

.play-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  backdrop-filter: blur(4px);
}

.video-thumbnail:hover .play-button {
  background: rgba(37, 99, 235, 0.8);
  transform: translate(-50%, -50%) scale(1.1);
}

/* Features Overview Section */
.features-overview-container {
  margin: 0px 0;
  width: 100%;
}

.feature-overview-image {
  width: 100% !important;
  max-width: 100%;
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  background: #ffffff;
  aspect-ratio: 16/9;
  box-shadow: 0 20px 40px rgba(255, 254, 254, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-overview-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.overview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.feature-overview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.feature-highlight {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.feature-highlight.left {
  top: 20%;
  left: 5%;
}

.feature-highlight.right {
  top: 60%;
  right: 5%;
}

.highlight-dot {
  width: 8px;
  height: 8px;
  background: #1a1a1a;
  border-radius: 50%;
}

.highlight-text {
  font-size: 14px;
  font-weight: 500;
  color: #1a1a1a;
}

.feature-overview-caption {
  text-align: center;
  margin-top: 24px;
}

.caption-text {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.caption-subtext {
  font-size: 16px;
  color: #666666;
}

/* Platforms Section */
.platforms-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 32px;
  margin-top: 32px;
}

.platform-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 20px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.platform-card:hover {
  border-color: #d1d5db;
  transform: translateY(-6px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
}

.platform-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.platform-logo {
  width: 40px;
  height: 40px;
  object-fit: contain;
  transition: all 0.3s ease;
}

.platform-card span {
  font-size: 1rem;
  color: #666;
  font-weight: 500;
  text-align: center;
}

/* Features Section */
.features-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  margin-top: 32px;
}

.feature-card {
  padding: 40px 32px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 20px;
  text-align: center;
  transition: all 0.3s ease;
}

.feature-card:hover {
  border-color: #d1d5db;
  transform: translateY(-6px);
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.1);
}

.feature-icon {
  width: 56px;
  height: 56px;
  background: #f8f9fa;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px auto;
  color: #2563eb;
}

.feature-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 16px 0;
}

.feature-card p {
  font-size: 1rem;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

/* FAQ Section */
.faq-container {
  max-width: 900px;
  margin: 0 auto;
  overflow: visible !important;
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  height: auto !important;
  overflow: visible !important;
}

.faq-item {
  position: relative;
  padding: 24px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1;
}

.faq-item:hover {
  border-color: #d1d5db;
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  z-index: 10;
}

.faq-question {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.faq-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.95), rgba(96, 165, 250, 0.95));
  color: #ffffff;
  padding: 16px 20px;
  border-radius: 12px;
  font-size: 0.95rem;
  line-height: 1.5;
  z-index: 9999;
  margin-top: 8px;
  box-shadow: 0 8px 30px rgba(37, 99, 235, 0.2);
}

.faq-tooltip::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #2563eb;
}

/* Footer */
.footer {
  background: #f8f9fa;
  border-top: 1px solid #e5e5e5;
  padding: 40px 0;
  margin-top: 100px;
}

.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
  color: #666;
  font-size: 0.9rem;
}

.footer-content a {
  color: #666;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-content a:hover {
  color: #2563eb;
  text-decoration: underline;
}

/* 汉堡菜单图标样式 */
.hamburger {
  width: 24px;
  height: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.hamburger span {
  display: block;
  height: 3px;
  background: #333;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.hamburger.active span:nth-child(1) {
  transform: translateY(8.5px) rotate(45deg);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: translateY(-8.5px) rotate(-45deg);
}

/* 移动端侧边抽屉 */
.mobile-drawer {
  position: fixed;
  top: 56px;
  left: 0;
  width: 155px;
  max-width: 85vw;
  height: auto;
  max-height: calc(100vh - 56px);
  background: #fff;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.12);
  border-radius: 0 0 16px 0;
  z-index: 999;
  overflow-y: auto;
}

.drawer-nav {
  padding: 12px 0 16px 0;
}

.drawer-nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 12px;
  color: #333;
  text-decoration: none;
  font-size: 15px;
  transition: all 0.2s ease;
  cursor: pointer;
  border-left: 3px solid transparent;
}

.drawer-nav-link:hover {
  background: #f8f9fa;
  color: #1890ff;
}

.drawer-nav-link.active {
  background: #e6f7ff;
  color: #1890ff;
  border-left-color: #1890ff;
  font-weight: 500;
}

.drawer-nav-link iconify-icon {
  color: inherit;
}

/* 抽屉动画 */
.drawer-slide-enter-active, .drawer-slide-leave-active {
  transition: transform 0.3s ease;
}

.drawer-slide-enter-from, .drawer-slide-leave-to {
  transform: translateX(-100%);
}

/* Responsive Design */
@media (max-width: 768px) {
  /* 导航栏容器 */
  .header {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
  
  .header .container {
    padding: 0 12px;
  }
  
  .nav {
    height: 56px;
    gap: 0;
    justify-content: flex-start;
  }
  
  /* Logo 适配 - 移动端靠左 */
  .logo {
    flex-shrink: 0;
    flex-basis: auto;
    margin-left: 4px;
  }
  
  .logo-icon {
    width: 28px !important;
    height: 28px !important;
    margin-right: 6px;
  }
  
  .logo span {
    font-size: 16px !important;
    font-weight: 600;
  }
  
  /* 隐藏桌面端导航，显示汉堡菜单 */
  .desktop-nav {
    display: none !important;
  }
  
  .mobile-menu-btn {
    display: flex !important;
    align-items: center;
    justify-content: center;
    margin-right: 0;
    padding: 8px;
  }
  
  /* 让右侧按钮组靠右 */
  .nav-actions {
    margin-left: auto;
  }
  
  
  /* 按钮组调整 */
  .nav-actions {
    gap: 8px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
  }
  
  .register-btn, .login-btn {
    padding: 7px 14px !important;
    font-size: 14px !important;
    border-radius: 6px !important;
  }
  
  /* 主要内容适配 */
  .hero {
    padding: 60px 0;
  }
  
  .hero-title {
    font-size: 2.5rem;
    line-height: 1.2;
  }
  
  .hero-subtitle {
    font-size: 1.2rem;
  }
  
  .hero-description {
    font-size: 1rem;
  }
  
  .section {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 1.8rem;
  }
  
  .container {
    padding: 0 20px;
  }
  
  .video-container video {
    height: 300px;
  }
  
  .platforms-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  
  .platform-card {
    padding: 20px 16px;
  }
  
  .features-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .feature-card {
    padding: 24px 20px;
  }
  
  .faq-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .faq-item {
    padding: 16px;
  }
  
  .faq-question {
    font-size: 1rem;
  }
  
  /* 用户菜单适配 */
  .user-info {
    padding: 6px 12px;
  }
  
  .user-menu {
    width: 280px !important;
  }
  
  .user-menu-header {
    padding: 16px;
  }
  
  .user-details {
    flex: 1;
  }
  
  .user-name {
    font-size: 14px;
  }
  
  .user-email {
    font-size: 12px;
  }
  
  /* 按钮适配 */
  .btn {
    padding: 12px 24px;
    font-size: 14px;
  }
  
  .btn-large {
    padding: 14px 28px;
    font-size: 16px;
  }
  
  /* 表格适配 */
  .dashboard-table {
    font-size: 12px;
  }
  
  .dashboard-table th,
  .dashboard-table td {
    padding: 8px 4px;
  }
  
  /* 下载区域适配 */
  .download-section {
    padding: 60px 0;
  }
  
  .download-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .download-card {
    padding: 24px 20px;
  }
  
  .download-card h3 {
    font-size: 1.2rem;
  }
  
  .download-card p {
    font-size: 0.9rem;
  }
  
  /* 功能展示适配 */
  .features-overview-container {
    flex-direction: column;
    gap: 30px;
  }
  
  .feature-overview-image {
    width: 100% !important;
    max-width: 100%;
    height: auto;
    aspect-ratio: 16/9;
    flex-shrink: 0;
  }
  
  .feature-overview-content {
    width: 100%;
    padding: 0;
  }
  
  .feature-overview-content h3 {
    font-size: 1.5rem;
  }
  
  .feature-overview-content p {
    font-size: 0.95rem;
  }
  
  /* 定价区域适配 */
  .pricing-section {
    padding: 60px 0;
  }
  
  .pricing-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .pricing-card {
    padding: 24px 20px;
  }
  
  .pricing-card h3 {
    font-size: 1.3rem;
  }
  
  .pricing-card .price {
    font-size: 2rem;
  }
  
  /* 联系区域适配 */
  .contact-section {
    padding: 60px 0;
  }
  
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .contact-card {
    padding: 24px 20px;
  }
  
  .contact-card h3 {
    font-size: 1.2rem;
  }
  
  /* 页脚适配 */
  .footer {
    padding: 30px 0;
  }
  
  .footer-content {
    font-size: 0.8rem;
  }
  
  /* 平板设备适配 */
  @media (min-width: 769px) and (max-width: 1024px) {
    .nav-links {
      gap: 12px;
    }
    
    .nav-link {
      font-size: 14px;
    }
    
    .register-btn, .login-btn {
      padding: 6px 14px;
      font-size: 14px;
    }
    
    /* 确保汉堡菜单隐藏 */
    .mobile-menu-btn {
      display: none !important;
    }
    
    .desktop-nav {
      display: flex !important;
    }
    
    .hero-title {
      font-size: 3rem;
    }
    
    .hero-subtitle {
      font-size: 1.4rem;
    }
    
    .section {
      padding: 70px 0;
    }
    
    .section-title {
      font-size: 2.2rem;
    }
    
    .container {
      padding: 0 30px;
    }
    
    .platforms-grid {
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
    }
    
    .features-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
    
    .faq-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }
    
    .features-overview-container {
      gap: 40px;
    }
    
    .feature-overview-image {
      width: 45%;
      height: 400px;
    }
    
    .feature-overview-content {
      width: 55%;
    }
    
    .pricing-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
    
    .contact-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
    }
  }
  
  
  /* 小屏手机适配 */
  @media (max-width: 480px) {
    /* 导航栏进一步优化 */
    .header .container {
      padding: 0 8px;
    }
    
    .nav {
      height: 52px;
      gap: 6px;
    }
    
    .logo-icon {
      width: 26px !important;
      height: 26px !important;
      margin-right: 5px;
    }
    
    .logo span {
      font-size: 15px !important;
    }
    
    .register-btn, .login-btn {
      padding: 6px 12px !important;
      font-size: 13px !important;
    }
    
    /* 进一步缩小头像与箭头，仅影响图标本身 */
    .user-avatar-icon {
      font-size: 14px !important;
    }
    
    .dropdown-icon {
      font-size: 11px !important;
    }
    
    /* 抽屉调整 */
    .mobile-drawer {
      top: 52px;
      max-height: calc(100vh - 52px);
    }
    
    .user-menu {
      width: 260px !important;
    }
    
    /* 移动端抽屉优化 */
    .mobile-drawer {
      width: 155px;
      border-radius: 0 0 12px 0;
    }
    
    .drawer-nav {
      padding: 6px 0 12px 0;
    }
    
    .drawer-nav-link {
      padding: 10px 12px;
      font-size: 14px;
      gap: 8px;
    }
    
    .drawer-nav-link iconify-icon {
      width: 16px !important;
      height: 16px !important;
    }
    
    /* 其他内容区域 */
    .hero {
      padding: 40px 0;
    }
    
    .hero-title {
      font-size: 2rem;
    }
    
    .hero-subtitle {
      font-size: 1rem;
    }
    
    .hero-description {
      font-size: 1rem;
    }
    
    .section {
      padding: 40px 0;
    }
    
    .section-title {
      font-size: 1.5rem;
    }
    
    .container {
      padding: 0 15px;
    }
    
    .platforms-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }
    
    .platform-card {
      padding: 16px 12px;
    }
    
    .feature-card {
      padding: 20px 16px;
    }
    
    .faq-item {
      padding: 12px;
    }
    
    .btn {
      padding: 10px 20px;
      font-size: 13px;
    }
    
    .btn-large {
      padding: 12px 24px;
      font-size: 15px;
    }
  }
  
  /* 超小屏手机适配（360px以下） */
  @media (max-width: 360px) {
    .header .container {
      padding: 0 6px;
    }
    
    .nav {
      height: 50px;
      gap: 4px;
    }
    
    .logo-icon {
      width: 24px !important;
      height: 24px !important;
      margin-right: 4px;
    }
    
    .logo span {
      font-size: 14px !important;
    }
    
    .register-btn, .login-btn {
      padding: 6px 10px !important;
      font-size: 12px !important;
    }
    
    /* 超小屏进一步缩小头像与箭头，仅影响图标本身 */
    .user-avatar-icon {
      font-size: 12px !important;
    }
    
    .dropdown-icon {
      font-size: 10px !important;
    }
    
    /* 抽屉调整 */
    .mobile-drawer {
      top: 50px;
      max-height: calc(100vh - 50px);
    }
    
    /* 抽屉进一步优化 */
    .mobile-drawer {
      width: 145px;
      border-radius: 0 0 10px 0;
    }
    
    .drawer-nav {
      padding: 4px 0 10px 0;
    }
    
    .drawer-nav-link {
      padding: 9px 10px;
      font-size: 13px;
      gap: 8px;
    }
  }
  
  /* 横屏手机适配 */
  @media (max-width: 900px) and (max-height: 600px) {
    .hero {
      padding: 30px 0;
    }
    
    .section {
      padding: 40px 0;
    }
    
    .hero-title {
      font-size: 2.2rem;
    }
    
    .hero-subtitle {
      font-size: 1.1rem;
    }
    
    .features-overview-container {
      flex-direction: column;
      gap: 20px;
    }
    
    .feature-overview-image {
      width: 100% !important;
      height: auto;
      aspect-ratio: 16/9;
    }
    
    .feature-overview-content {
      width: 100%;
    }
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 16px;
  }
  
  .nav-container {
    padding: 0 16px;
  }
  

  
  .platforms-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .platform-card {
    padding: 24px 16px;
  }
  
  .platform-icon {
    width: 48px;
    height: 48px;
  }
  
  .video-container video {
    height: 300px;
  }
}

body {
  margin: 0;
  font-family: 'Inter', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  background: #fff;
}
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.header {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header .container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  gap: 12px;
}

/* 移动端汉堡菜单按钮 - 默认隐藏 */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  z-index: 1001;
  transition: transform 0.2s ease;
  order: -1; /* 确保在最左边 */
}

.mobile-menu-btn:active {
  transform: scale(0.95);
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-weight: 600;
  font-size: 20px;
  flex-shrink: 0;
}
.logo span {
  font-size: 20px;
  color: #333;
  font-weight: 600;
  margin-left: 2px;
}
.logo-icon {
  height: 32px;
  width: 32px;
  margin-right: 8px;
  object-fit: contain;
  border-radius: 4px;
}
.nav-links {
  display: flex;
  gap: 24px;
  flex: 0 1 auto;
  min-width: 0;
  align-items: center;
}

/* 桌面端导航默认显示 */
.desktop-nav {
  display: flex;
}
.nav-link {
  color: #666;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.2s, background-color 0.2s;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
}
.nav-link:hover {
  color: #1890ff;
}
.nav-link.active {
  color: #1890ff;
  font-weight: 500;
}
.nav-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.register-btn {
  background: #fff;
  color: #1890ff;
  border: 1px solid #1890ff;
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  margin-right: 12px;
  transition: background-color 0.2s, color 0.2s;
}
.register-btn:hover {
  background: #e6f7ff;
  color: #40a9ff;
}
.login-btn {
  background: #1890ff;
  color: #fff;
  border: none;
  padding: 8px 20px;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.login-btn:hover {
  background: #40a9ff;
}
.icon-btn {
  background: #fff;
  border: 1.5px solid #1890ff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  padding: 0;
}
.icon-btn:hover {
  background: #e6f7ff;
  border-color: #1765ad;
}
.user-btn svg, .home-btn svg {
  display: block;
  width: 20px;
  height: 20px;
}
.page-content {
  padding-top: 0px;
}
.el-menu-item {
  border-radius: 20px;
  background-color: rgba(
    255,
    255,
    255,
    0.3
  ); /* 淡白色背景，可根据实际情况调整颜色和透明度 */
}
/* 定义选中状态下的样式，鼠标移开也保持背景颜色及字体变蓝 */
:deep(.el-menu-item.active) {
  border-radius: 20px; /* 减小圆角大小，使背景框更小 */
  display: inline-flex; /* 让背景框仅包裹内容 */
  padding: 0 10px;  /* 适当添加内边距，使背景框与文字有一定间距 */
  background-color: rgba(194, 190, 190, 0.906); /* 淡白色背景稍深，可根据实际情况调整 */
  color: rgba(55, 119, 237, 0.888); /* 字体变蓝色 */
}

/* 鼠标悬停时也应用相同样式 */
.el-menu-item:hover {
  border-radius: 20px; /* 减小圆角大小，使背景框更小 */
  display: inline-flex; /* 让背景框仅包裹内容 */
  /*padding: 0 10px;  适当添加内边距，使背景框与文字有一定间距 */
  background-color: rgba(191, 190, 194, 0.906); /* 鼠标悬停时淡白色背景稍深，可根据实际情况调整 */
  color: rgba(55, 119, 237, 0.888); /* 鼠标悬停时字体变蓝色 */
}
/* 注意：此样式已被移除，使用第809行的.container样式定义 */
/* 如果需要特定容器的样式，请使用更具体的选择器 */

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
  /* 调整导航栏高度，可根据实际需求修改值 */
  height: 60px;
}

.fixed-navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  /* 确保导航栏在其他内容之上 */
  box-shadow: 0 2px 4px rgba(81, 86, 85, 0.1);
  /* 可选：添加阴影以提升视觉效果 */
}

/* 移除冲突的logo样式，保持原有的logo格式 */

.auth-buttons {
  display: flex;
  gap: 0px;
  color: #008000; /* 修改颜色为绿色 */
}
.auth-buttons .el-button--text {
  color: #008000; /* 修改按钮字体颜色为绿色 */
}

.main-content1 {
  margin-top: auto; /* 避免被固定导航栏遮挡 */
  margin-left: auto;
  margin-right: auto;
   min-height: 100vh;
  box-sizing: border-box;
  /* background-color: linear-gradient(90deg, rgb(228, 235, 255) 8%, rgba(228, 235, 255, 0) 22%, rgba(228, 235, 255, 0) 77%, rgb(228, 235, 255) 91%), radial-gradient(27% 99% at 64% -12%, rgb(252, 229, 229) 0%, rgba(228, 235, 255, 0) 100%), radial-gradient(27% 105% at 27% 119%, rgb(208, 203, 255) 0%, rgba(228, 235, 255, 0) 100%), rgb(228, 235, 255); */
}
.hero1 {
  text-align: center;
  background: linear-gradient(90deg, rgb(228, 235, 255) 8%, rgba(228, 235, 255, 0) 22%, rgba(228, 235, 255, 0) 77%, rgb(228, 235, 255) 91%), radial-gradient(27% 99% at 64% -12%, rgb(252, 229, 229) 0%, rgba(228, 235, 255, 0) 100%), radial-gradient(27% 105% at 27% 119%, rgb(208, 203, 255) 0%, rgba(228, 235, 255, 0) 100%), rgb(228, 235, 255);
}
.custom-button {
  width: 200px; 
  height: 70px; 
  font-size: 30px; 
  border-radius: 20px;
  background: linear-gradient(106deg, #c676ff, #654cff 41%, #405eff 75%, #007fff 99%);
  /* color:linear-gradient(106deg, #c676ff, #654cff 41%, #405eff 75%, #007fff 99%); */
}

.hero1 h1 {
  font-size: 60px; /* 调整字体大小 */
  color: #333333; /* 调整字体颜色 */
  font-weight: bold; /* 加粗字体 */
  margin-bottom: 10px; /* 调整h1和p之间的间距 */
}
.hero1 p {
  margin-bottom: 50px; /* 调整文字与按钮之间的间距 */
  font-size: 30px; /* 调整字体大小 */
  font-family: '思源黑体 SC';
}

.main-content2 {
  margin-top: auto; /* 避免被固定导航栏遮挡 */
  margin-left: auto;
  margin-right: auto;
  padding-left: 10%;
  padding-right: 10%;
   min-height: 100vh;
  box-sizing: border-box;
  background: rgb(240, 247, 255);
}
.hero2h {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  background: rgb(240, 247, 255);
   margin-bottom: 20px; /* 调整h1和p之间的间距 */
}
.hero2h h1 {
  font-size: 60px; /* 调整字体大小 */
  color: #333333; /* 调整字体颜色 */
  font-weight: bold; /* 加粗字体 */
}

.hero2 {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  background: rgb(240, 247, 255);
}
/* 新增内容样式 */
.hero2 .el-row {
  margin-left: -0px;
  margin-right: -0px;
}
.hero2 .el-col {
  padding-left: 0px;
  padding-right: 0px;
}


.hero2 h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px; 
}

.hero2 p {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  text-align: left; /* 文字左对齐 */
}


.main-content {
  margin-top: auto; /* 避免被固定导航栏遮挡 */
  margin-left: auto;
  margin-right: auto;
  padding-left: 10%;
  padding-right: 10%;
   min-height: 100vh;
  box-sizing: border-box;
  /* background-color: linear-gradient(90deg, rgb(228, 235, 255) 8%, rgba(228, 235, 255, 0) 22%, rgba(228, 235, 255, 0) 77%, rgb(228, 235, 255) 91%), radial-gradient(27% 99% at 64% -12%, rgb(252, 229, 229) 0%, rgba(228, 235, 255, 0) 100%), radial-gradient(27% 105% at 27% 119%, rgb(208, 203, 255) 0%, rgba(228, 235, 255, 0) 100%), rgb(228, 235, 255); */
}


.hero-img {
  margin-top: 40px; /* 调整按钮与图片之间的间距 */
}
.hero-img1 {
  width: 60%; 
  height: auto;
  margin-bottom: 10%; 
  transition: transform 0.3s ease; 
  border: 15px solid linear-gradient(90deg, rgb(246, 247, 249) 8%, rgba(228, 235, 255, 0) 22%, rgba(228, 235, 255, 0) 77%, rgb(242, 244, 250) 91%), radial-gradient(27% 99% at 64% -12%, rgb(246, 243, 243) 0%, rgba(228, 235, 255, 0) 100%), radial-gradient(27% 105% at 27% 119%, rgb(227, 225, 244) 0%, rgba(228, 235, 255, 0) 100%), rgb(234, 237, 244);
  border-radius: 4px; 
  box-shadow: 0 4px 8px rgba(238, 237, 240, 0.1);
}

.featurestitle {
  margin: 40px 0;
  text-align: center;
}

.features {
  margin: 40px 0;
  /* text-align: center; */
}

.feature-card {
  text-align: center;
  padding: 20px;
}

.testimonials {
  margin: 40px 0;
}

.case-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.case-info h4 {
  margin: 0 0 5px;
}

.position {
  color: #666;
  font-size: 14px;
}

.quote {
  color: #999;
  font-style: italic;
}

.faq-section {
  padding: 40px 0;
  background: #f5f7fa;
  overflow: visible !important;
}

.contact-form {
  margin: 30px 0;
}

.bottom-cta {
  text-align: center;
  margin-top: 40px;
}

.hero h1 {
  font-size: 60px; /* 调整字体大小 */
  color: #333333; /* 调整字体颜色 */
  font-weight: bold; /* 加粗字体 */
  margin-bottom: 10px; /* 调整h1和p之间的间距 */
}


.collapse-title {
  font-size: 20px; /* 设置标题字体大小 */
  color: #131313ee; /* 设置标题字体颜色 */
  font-weight: bold; /* 加粗标题字体 */
  padding-left: 10px;
}
.collapse-answer {
  font-size: 16px; /* 设置字体大小 */
  color: #222020; /* 设置字体颜色 */
  font-weight: normal; /* 明确设置普通粗细 */
  padding-left: 10px;
}
.custom-dialog-body {
  height: calc(
    100% - 100px
  ); /* 根据弹窗高度动态调整，减去标题和底部按钮的高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
}
/* 下载中心样式 */
.download-center {
  text-align: center;
  padding: 40px;
}

.download-center h1 {
  font-size: 60px;
  margin-bottom: 30px;
}

.download-center p {
  font-size: 16px;
  margin-bottom: 40px;
}

.download-buttons .el-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 60px;
  font-size: 18px;
}

.download-buttons .el-button .el-icon {
  margin-right: 10px;
}
.download-buttons {
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 50px; /* 按钮之间的间距 */
}



.feature-list {
  display: flex;
  flex-direction: column;
  gap: 0px;
  /* 项目之间的间距 */
    /* background-color: rgb(255, 255, 255); */
}

.feature-item {
  position: relative;
  background-color: white;
  cursor: pointer;
  /* 鼠标悬停时显示手型 */
  transition: background-color 0.3s;
  /* 平滑过渡效果 */
   padding-right: 30px; /* 可按需修改右内边距的值 */
   padding-left: 30px; /* 可按需修改左内边距的值 */
}

.feature-item::after {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  /* 边框宽度 */
  height: var(--progress-height, 0%);
  background-color: #409eff;
  /* 蓝色边框颜色 */
  transition: height 0s linear;
}

.feature-item:hover {
  background-color: #9dd4f252;
  /* 鼠标悬停时的背景色 */
}
.feature-item h2 {
  color: #333;
}

.feature-item.selected {
  background-color: #b5dcf735; /* 可根据需求修改背景色 */
  color: white; /* 可根据需求修改文字颜色 */
}
.feature-item.selected h2 {
  color: rgb(0, 4, 252) !important;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.image-container img {
  max-width: 100%;
  height: 100%;
  display: block;
  /* margin: 0 auto; */
  object-fit: cover; /* 保持图片比例并覆盖容器 */
}
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.5s ease;
}

.slide-down-enter-from {
  transform: translateY(-0px);
  opacity: 0;
}

.slide-down-leave-to {
  transform: translateY(0px);
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
  position: absolute;
  /* 确保两张图在同一位置叠加 */
  top: 0;
  left: 0;
  width: 100%;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.download-buttons {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.download-button {
  width: 200px;
  height: 180px;
  background: linear-gradient(135deg, #1e7efc, #1a69f2);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  /* position: relative; */

/* &:hover {
    .icon, .content {
      opacity: 1;
      transform: scale(1.08);
    }
    .hover-arrow {
      display: block;
    }
  } */
}

.download-button .icon {
  font-size: 48px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

.download-button .content {
  text-align: center;
  transition: all 0.3s ease;
}

.download-button .title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.download-button .description {
  font-size: 14px;
}

.download-button::before {
  content: '↓';
  font-size: 16px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
}
/* 代码展示区自适应高度，无滚动条 */
pre, code, .code-block {
  max-height: none !important;
  height: auto !important;
  overflow: visible !important;
  white-space: pre-wrap;
  word-break: break-all;
}
/* FAQ Section 独立样式 */
.faq-section-custom {
  padding: 100px 0;
  /* background: #f8f9fa; */
  overflow: visible !important;
  min-height: 500px; /* 可根据需要调整 */
  height: auto;
}
.faq-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}
/* 用户信息区域样式 */
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border: 1px solid #e5e5e5;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.user-info:hover {
  background: linear-gradient(135deg, #f0f2f5, #ffffff);
  border-color: #d1d5db;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
}

.username {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0 4px;
  min-width: 16px;
  text-align: center;
}

.dropdown-icon {
  color: #666;
  transition: transform 0.2s ease;
  font-size: 14px;
}

.user-avatar-icon {
  font-size: 24px;
}

.user-info:hover .dropdown-icon {
  transform: rotate(180deg);
}

/* 用户菜单样式 - 无阴影无边距 */
.user-menu {
  padding: 0 !important;
  margin: 0 !important;
  background: #ffffff;
  border-radius: 0;
  box-shadow: none !important;
  border: 1px solid #e5e5e5;
  overflow: hidden;
}

.user-menu-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 20px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 1px solid #e5e5e5;
  border-radius: 0;
  margin: 0;
  min-height: 64px;
}

.user-avatar-large {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2563eb;
}

.user-details {
  flex: 1;
}

.user-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.user-email {
  font-size: 12px;
  color: #666;
}

.user-menu-divider {
  height: 1px;
  background: #e5e5e5;
  margin: 0;
}

.user-menu-items {
  padding: 0 !important;
  border-radius: 0;
  margin: 0 !important;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #333;
  border-radius: 0;
  background: transparent;
  margin: 0 !important;
}

.menu-item:hover {
  background: linear-gradient(135deg, #f0f2f5, #ffffff);
  color: #2563eb;
  border-radius: 0;
}

.menu-item span {
  font-size: 14px;
  font-weight: 500;
}

.menu-item iconify-icon {
  color: inherit;
}

/* 确保用户菜单不受全局el-menu-item样式影响 */
.user-menu .menu-item {
  border-radius: 0 !important;
  background-color: transparent !important;
  display: flex !important;
  padding: 12px 20px !important;
}

.user-menu .menu-item:hover {
  border-radius: 0 !important;
  background-color: rgba(240, 242, 245, 0.8) !important;
  color: #2563eb !important;
}

/* 强制去除所有圆角和阴影、边距 */
.user-menu, .user-menu * {
  border-radius: 0 !important;
  box-shadow: none !important;
  margin: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

/* 用户菜单样式 - 内容区与外框齐平 */
.user-menu,
.user-menu * {
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.user-menu-header {
  display: flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 1px solid #e5e5e5;
  min-height: 64px;
}

.user-menu-items {
  border-radius: 0;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #333;
  border-radius: 0;
  background: transparent;
}

.menu-item:hover {
  background: linear-gradient(135deg, #f0f2f5, #ffffff);
  color: #2563eb;
  border-radius: 0;
}

/* 下载中心新样式 */
.download-root {
  min-height: calc(100vh - 60px);
  background-color: #f8fafc;
  padding: 40px 0;
}

.download-content {
  width: 100%;
}

.download-content .container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.page-title {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.download-tip {
  color: #666;
  font-size: 14px;
  margin-bottom: 48px;
}

.tutorial-link {
  color: #2563eb;
  text-decoration: none;
}

.tutorial-link:hover {
  text-decoration: underline;
}

.download-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  max-width: 800px;
  margin: 0 auto;
}

.download-card {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transition: all 0.2s;
  cursor: pointer;
}

.download-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
}

.download-platform-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 图标使用内联 svg 且 fill="currentColor"，需要提供对比色背景，否则白色会“看不见” */
  color: #ffffff;
  background: linear-gradient(135deg, #2563eb, #60a5fa);
  border-radius: 16px;
}

.download-platform-icon svg {
  width: 40px;
  height: 40px;
}

.download-platform-icon.disabled {
  color: #94a3b8;
  background: #f1f5f9;
}

.platform-info {
  text-align: center;
}

.platform-info h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.platform-support {
  color: #666;
  font-size: 14px;
}

.btn-download {
  background: #2563eb;
  color: white;
  border: none;
  padding: 10px 32px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-download:hover {
  background: #1d4ed8;
}

.btn-download.disabled {
  background: #94a3b8;
  cursor: not-allowed;
}

.btn-download.disabled:hover {
  background: #94a3b8;
}

  /* 手机竖屏 */
  @media (max-width: 600px) {
    .el-dialog {
      width: 100vw !important;
      max-width: 100vw !important;
      min-width: 0 !important;
      padding: 0 !important;
      left: 0 !important;
      margin: 0 !important;
      border-radius: 0 !important;
    }
    .el-dialog__body {
      padding: 10px !important;
      word-break: break-all;
    }
    .el-dialog__footer {
      padding: 10px !important;
    }
  }
  
  /* 手机横屏 */
  @media (min-width: 601px) and (max-width: 900px) and (max-height: 600px) {
    .el-dialog {
      width: 98vw !important;
      max-width: 98vw !important;
      min-width: 0 !important;
      padding: 0 !important;
      left: 1vw !important;
      margin: 0 !important;
      border-radius: 8px !important;
    }
    .el-dialog__body {
      padding: 8px !important;
      word-break: break-all;
    }
    .el-dialog__footer {
      padding: 8px !important;
    }
  }
  
  /* 平板设备 */
  @media (min-width: 601px) and (max-width: 1024px) and (min-height: 601px) {
    .el-dialog {
      width: 92vw !important;
      max-width: 92vw !important;
      min-width: 0 !important;
      padding: 0 !important;
      left: 4vw !important;
      margin: 0 !important;
      border-radius: 10px !important;
    }
    .el-dialog__body {
      padding: 12px !important;
      word-break: break-all;
    }
    .el-dialog__footer {
      padding: 12px !important;
    }
  }
  
  /* 大屏平板和桌面 */
  @media (min-width: 1025px) and (max-width: 1400px) {
    .el-dialog {
      width: 75vw !important;
      max-width: 75vw !important;
      min-width: 0 !important;
      padding: 0 !important;
      left: 12.5vw !important;
      margin: 0 !important;
      border-radius: 10px !important;
    }
  }

  /* 浮动通知样式 - 避免被识别为广告 */
  .floating-notice {
    position: fixed;
    top: 205px;
    left: 20px;
    z-index: 1000;
    width: 280px;
    max-width: 90vw;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    animation: slideIn 0.5s ease-out;
    min-height: 120px;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .notice-content {
    position: relative;
    padding: 20px;
    color: white;
    min-height: 72px;
  }

  .notice-text-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .notice-title {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 2px 0;
    line-height: 1.2;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.8);
  }

  .notice-text {
    font-size: 14px;
    line-height: 1.4;
    margin: 0;
    font-weight: 400;
    text-shadow: 0 1px 6px rgba(0, 0, 0, 0.8);
  }

  .apply-link {
    color: #ffffff;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
    transition: all 0.2s ease;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.9);
  }

  .apply-link:hover {
    color: #e0e7ff;
    text-shadow: 0 2px 10px rgba(255, 255, 255, 0.3);
  }

  .close-notice {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    transition: all 0.2s ease;
    z-index: 10;
  }

  .close-notice:hover {
    background: rgba(0, 0, 0, 0.8);
    border-color: rgba(255, 255, 255, 0.5);
    transform: scale(1.1);
  }

  @keyframes slideIn {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  /* 响应式适配 */
  @media (max-width: 768px) {
    .activity-fab {
      top: 68px;
      left: 10px;
      width: 240px;
      right: 10px;
      max-width: none;
    }

    .floating-notice {
      top: 185px;
      left: 10px;
      width: 240px;
      right: 10px;
      max-width: none;
      border-radius: 8px;
      min-height: 110px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .notice-content {
      padding: 16px;
    }

    .notice-title {
      font-size: 15px;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 0.9);
    }

    .notice-text {
      font-size: 13px;
      text-shadow: 0 1px 6px rgba(0, 0, 0, 0.9);
    }

    .close-notice {
      top: 6px;
      right: 6px;
      width: 22px;
      height: 22px;
      font-size: 16px;
      background: rgba(0, 0, 0, 0.7);
      border: 1px solid rgba(255, 255, 255, 0.4);
    }
  }

  @media (max-width: 480px) {
    .activity-fab {
      top: 64px;
      left: 10px;
      width: calc(100vw - 20px);
      right: 10px;
      max-width: none;
    }

    .floating-notice {
      top: 180px;
      width: calc(100vw - 20px);
      left: 10px;
      right: 10px;
      border-radius: 8px;
      min-height: 100px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .notice-content {
      padding: 14px;
    }

    .notice-title {
      font-size: 14px;
      text-shadow: 0 3px 10px rgba(0, 0, 0, 1);
    }

    .notice-text {
      font-size: 12px;
      text-shadow: 0 2px 8px rgba(0, 0, 0, 1);
    }

    .close-notice {
      top: 6px;
      right: 6px;
      width: 20px;
      height: 20px;
      font-size: 14px;
      background: rgba(0, 0, 0, 0.7);
      border: 1px solid rgba(255, 255, 255, 0.5);
    }
  }

  /* 活动入口卡片（左上角，新人福利上方） */
  .activity-fab {
    position: fixed;
    top: 80px;
    left: 20px;
    z-index: 1001;
    width: 280px;
    max-width: 90vw;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(245, 158, 11, 0.4);
    overflow: hidden;
    animation: slideIn 0.5s ease-out;
    min-height: 120px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: linear-gradient(135deg, #f59e0b 0%, #f97316 100%);
    text-decoration: none;
    display: block;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .activity-fab:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(245, 158, 11, 0.55);
  }

  .activity-fab-content {
    position: relative;
    padding: 20px;
    color: white;
  }

  .activity-fab-text-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .activity-fab-title {
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 2px 0;
    line-height: 1.2;
    color: #fff;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  }

  .activity-fab-desc {
    font-size: 14px;
    line-height: 1.4;
    margin: 0;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.92);
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  }

  @media (max-width: 480px) {
    .activity-fab {
      top: 64px;
      padding: 12px 16px;
    }
  }
</style>

